import http from "../lib/http";

export const getVendorWithProducts = async (uniqueName, params = {}) => {
  try {
    const response = await http.get(
      `/api/customer/vendors/unique_name/${uniqueName}/products`,
      { params }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching vendor details with products:", error);
    throw error;
  }
};